import { render, staticRenderFns } from "./PowraF.vue?vue&type=template&id=68af9af9&"
import script from "./PowraF.vue?vue&type=script&lang=js&"
export * from "./PowraF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports